import type { ValueOf } from '#layers/base/public';

export const IndexKind = {
	Primary: 'primary',
	Unique: 'unique',
	Normal: 'normal',
} as const;

export const INDEX_KINDS = [
	IndexKind.Normal,
	IndexKind.Unique,
	IndexKind.Primary,
];

export type IndexKind = ValueOf<typeof IndexKind>;

export const ReferentialAction = {
	Cascade: 'cascade',
	Restrict: 'restrict',
	NoAction: 'noAction',
	SetNull: 'setNull',
	SetDefault: 'setDefault',
} as const;

export type ReferentialAction = ValueOf<typeof ReferentialAction>;
